const TOKEN_KEY = 'accessToken';

export const getStoredApiAccessToken = () => localStorage.getItem(TOKEN_KEY);

export const setStoredApiAccessToken = (accessToken) => localStorage.setItem(TOKEN_KEY, accessToken);

export const clearStoredApiAccessToken = () => localStorage.removeItem(TOKEN_KEY);